import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-317bd7be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = { class: "form-wrap" }
const _hoisted_3 = { style: {"margin-top":"20px","word-wrap":"break-word"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 当前信息： ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_6 = {
  key: 0,
  style: {"padding-bottom":"20px"}
}
const _hoisted_7 = {
  key: 0,
  class: "form-wrap"
}
const _hoisted_8 = { style: {"word-wrap":"break-word"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 公网地址： ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("测试")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { style: {"word-wrap":"break-word"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 内网地址： ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("测试")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 当前已设置外部访问链接，如果点击测试按钮后，可以打开当前服务，则代表测试通过，可使用PT管理宝小程序扫描下方二维码绑定。 ", -1))
const _hoisted_17 = { style: {"text-align":"center"} }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","color":"red"} }, "二维码千万不要泄露！", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_22 = { class: "form-wrap" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("IPv4")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("IPv6")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, " 公网地址用于从外部环境访问辅助程序的情况，如有ipv4公网地址尽量选择ipv4环境，速度更快。内网地址用于在局域网内直连辅助程序的情况，速度最快，但有局限性。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_page_container = _resolveComponent("page-container")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_key_outlined = _resolveComponent("key-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_container, {
      title: "设置外部可访问链接",
      "sub-title": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_alert, {
              message: "提示：PT管理宝需要从外部访问本辅助程序，所以需要设置一个外部可访问链接。建议使用DDNS域名或者固定ip，请注意可能需要端口转发！(PS:DDNSTO这个穿透工具不支持，推荐ngrok,frp,nps等)",
              type: "warning"
            }),
            _createElementVNode("p", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_a_tag, {
                style: {"cursor":"pointer"},
                color: "cyan",
                onClick: _ctx.setOpenLink
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            (!_ctx.remoteUrl)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, " 当前未设置相关信息，请点击上方设置按钮进行相关设置 "))
              : _createCommentVNode("", true)
          ]),
          (_ctx.remoteUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, [
                  _hoisted_9,
                  (_ctx.remoteUrl)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        style: {"cursor":"pointer"},
                        color: "green",
                        onClick: _ctx.testOpenLink
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isIPv6 ? "IPv6" : "IPv4"), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.remoteUrl)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        style: {"cursor":"pointer"},
                        color: "purple",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.testOpenLink(_ctx.remoteUrl)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_11,
                  _createVNode(_component_a_tag, {
                    style: {"width":"100%","margin-top":"10px"},
                    color: _ctx.remoteUrl ? 'blue' : 'red'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.remoteUrl || "暂未绑定，绑定后才可正常使用"), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _createElementVNode("p", _hoisted_12, [
                  _hoisted_13,
                  (_ctx.localUrl)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        style: {"cursor":"pointer"},
                        color: "purple",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.testOpenLink(_ctx.localUrl)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_15,
                  _createVNode(_component_a_tag, {
                    style: {"width":"100%","margin-top":"10px"},
                    color: _ctx.localUrl ? 'blue' : 'red'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.localUrl || "暂未绑定，绑定后才可正常使用"), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.bindCodeUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.bindCodeUrl,
                        alt: "绑定二维码"
                      }, null, 8, _hoisted_18))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_19
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      title: "设置外部可访问链接",
      placement: "bottom",
      visible: _ctx.visible,
      closable: false,
      maskClosable: false,
      height: "60%",
      onClose: _ctx.closeDrawer
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          style: {"margin-right":"8px"},
          disabled: _ctx.submitLoading,
          onClick: _ctx.closeDrawer
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: _ctx.submitLoading,
          loading: _ctx.submitLoading,
          onClick: _ctx.sumbitHandle
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_a_form, {
            ref: "formEle",
            model: _ctx.formState,
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "remoteUrl",
                label: "公网地址"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: "如：http://abc.com:8081",
                    autocomplete: "",
                    value: _ctx.formState.remoteUrl,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.remoteUrl) = $event))
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_key_outlined, {
                        style: _normalizeStyle({ color: 'rgba(0,0,0,.25)' })
                      }, null, 8, ["style"])
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "remoteUrlType",
                label: "公网类型",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.formState.remoteUrlType,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.remoteUrlType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_button, { value: 10 }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio_button, { value: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "localUrl",
                label: "内网地址"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: "ip+端口号",
                    autocomplete: "",
                    value: _ctx.formState.localUrl,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.localUrl) = $event))
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_key_outlined, {
                        style: _normalizeStyle({ color: 'rgba(0,0,0,.25)' })
                      }, null, 8, ["style"])
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _hoisted_25
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ], 64))
}